<template>
    <div>
        <h1>{{ transl["STR_TITLE_CLIENTS"] }}</h1>
        <div>
            <i class="fas fa-search"></i>
            &nbsp;<input style="width: 230px;" type="text" v-model="filter" ref="pp" placeHolder="Suche..." />
        </div>
        <br>
        <table border="1">
        <thead>
            <th width="125" @click="sort('apoCustomerId')">
                <i v-if="showUpArrow('apoCustomerId')" class="fas fa-arrow-up"></i>
                <i v-if="showDownArrow('apoCustomerId')" class="fas fa-arrow-down"></i>
                {{ transl["STR_CUSTID"] }}</th>
            <th width="350"  @click="sort('name')">
                <i v-if="showUpArrow('name')" class="fas fa-arrow-up"></i>
                <i v-if="showDownArrow('name')" class="fas fa-arrow-down"></i>
                {{ transl["STR_NAME"] }}</th>
            <th width="250" @click="sort('apoEmail')">
                <i v-if="showUpArrow('apoEmail')" class="fas fa-arrow-up"></i>
                <i v-if="showDownArrow('apoEmail')" class="fas fa-arrow-down"></i>
                {{ transl["STR_EMAIL"] }}
            </th>
            <th width="250" @click="sort('apoContactPerson')">
                <i v-if="showUpArrow('apoContactPerson')" class="fas fa-arrow-up"></i>
                <i v-if="showDownArrow('apoContactPerson')" class="fas fa-arrow-down"></i>
                {{ transl["STR_CONTACT"] }}
            </th>
            <th width="150" @click="sort('apoPhone1')">
                <i v-if="showUpArrow('apoPhone1')" class="fas fa-arrow-up"></i>
                <i v-if="showDownArrow('apoPhone1')" class="fas fa-arrow-down"></i>
                {{ transl["STR_PHONE"] }}
            </th>
            <th width="60" @click="sort('apoPLZ')">
                <i v-if="showUpArrow('apoPLZ')" class="fas fa-arrow-up"></i>
                <i v-if="showDownArrow('apoPLZ')" class="fas fa-arrow-down"></i>
                {{ transl["STR_POSTCODE"] }}
            </th>
            <th width="90">{{ transl["STR_ACTIONS"] }}</th>
        </thead>
        
        <tr v-for="c in sortedClients" v-bind:key="c.id">
            <td>{{ c.apoCustomerId }}</td>    
            <td>{{ c.name }}</td>
            <td>{{ c.apoEmail }}</td>
            
            <td>{{ c.apoContactPerson }}</td>
            <td>{{ c.apoPhone1 }}</td>
            <td>{{ c.apoPLZ }}</td>
            <td align="center">
                <i v-on:click="editClient(c.id)" class="fas fa-pencil-alt" style="cursor: pointer;"></i>
                &ensp;
                <i v-on:click="openClient(c)" class="fas fa-eye" style="cursor: pointer;"></i>
            </td>
        </tr>
        <tr v-if="!sortedClients.length">
            <td v-if="this.filter===''" colspan="7" style="padding: 10px;">Sie haben bisher noch keine Aphotheken angelegt.</td>
            <td v-else colspan="7" style="padding: 10px;">Die Suche hat nichts gefunden.</td>
        </tr>
        <tr v-if="sortedClients.length">
            <td colspan="50">
                <table style="width: 100%">
                <tfoot>
                    <tr>
                        <td><button v-on:click="page--" :disabled="(this.offset*this.page)-this.offset == 0">&larr;</button></td>
                        <td colspan="3" align="center">Apotheke {{ (this.offset*this.page)-this.offset }} bis  {{ this.offset*this.page }} von {{ this.filteredClients.length }}</td>
                        <td align="right"><button v-on:click="page++" :disabled="this.offset*this.page >= this.filteredClients.length">&rarr;</button></td>
                    </tr>
                </tfoot>
                </table>  
            </td>
        </tr>
        </table>
        
        <div style="display: Flex">
            <div class="magic-button" style="margin-right: 15px" v-on:click="addClient()">
                {{ transl["STR_ADD_CLIENT"]}}
            </div>
        </div>

    </div>
</template>
<script>

export default({
    props: [ 'transl' ],
    data() {
        return {
            start: 0,
            offset: 20,
            page: 1,
            currentSort: "name",
            currentSortDir: "asc",
            filter:''
        }
    },
    computed: {
        filteredClients() {
            if(!this.$store.getters.getClients.length){
                return [];
            }
            const filterText = this.filter.toLowerCase();
            const filtered = this.$store.getters.getClients.filter(c => {
                if(this.filter == '') return true;
                return c.name.toLowerCase().indexOf(filterText) >= 0 || c.apoCustomerId.toLowerCase().indexOf(filterText) >= 0;
            })
            return filtered;
        },
        sortedClients() {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            const sorted = this.filteredClients.sort((a,b) => {
                let modifier = 1;
                if(this.currentSortDir === 'desc') modifier = -1;

                let aValue = a[this.currentSort] === null?'':a[this.currentSort].toLowerCase();
                let bValue = b[this.currentSort] === null?'':b[this.currentSort].toLowerCase();

                if(aValue < bValue) return -1 * modifier;
                if(aValue > bValue) return 1 * modifier;
                return 0;
            });
            return sorted.slice((this.offset*this.page)-this.offset,this.offset*this.page);
        }
    },
    watch: {
        filter() {
            //reset to 1 because filter changed
            this.page = 1;
        }
    },
    methods: {
        sort(s) {
            //if s == current sort, reverse
            if(s === this.currentSort) {
                this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
            }
            this.currentSort = s;
        },
        addClient() {     
            this.$router.push({
                name: 'EditClient',
                params: {
                    id: null
                }
            })
        },
        editClient(id) {
            this.$router.push({
                name: 'EditClient',
                params: {
                    id: id
                }
            })
        },
        openClient(user) {
            window.open("/login/"+user.apoCustomerId+"?email="+user.apoEmail+"&curves=true&isAdmin=true", "mywindow","menubar=1,resizable=1,width=1600,height=1000")   // &isAdmin=true
        },
        showUpArrow(value) {
            return (this.currentSort===value && this.currentSortDir==="asc")
        },
        showDownArrow(value){
            return (this.currentSort===value && this.currentSortDir==="desc")
        }
    }
})
</script>
